module.exports = __webpack_public_path__ + "static/img/egg_b_05.018bccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_05.png
// module id = bAQ4
// module chunks = 1